/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */
function mapToParentSection(data) {
  const countryDetails = !!data.country && typeof data.country.toJS === 'function' ? data.country.toJS() : data.country;
  return {
    bankName: data.bank,
    bankBranchCode: data.bankTypeCode === 'SWIFT Code' ? data.swiftCode : data.bankTypeCode === 'Bank Code' ? data.bankCodeOrRoutingNumber : '',
    bankBranchName: data.bankBranch,
    bankRoutingNumber: data.bankCodeOrRoutingNumber,
    bankAccountName: data.bankAccountName,
    bankAccountNumber: data.bankAccountNumber,
    creditorName: data.firstName,
    creditorSurname: data.lastName,
    creditorFullName: `${data.firstName} ${data.lastName}`,
    physicalAddress1: data.addressLine1,
    physicalAddress2: data.addressLine2,
    bankCodeType: data.bankTypeCode,
    bankAddress: data.bankAddress,
    bankPostcode: data.bankPostcode,
    bankSuburbOrCity: data.bankSuburbOrCity,
    npi: null,
    federalTaxId: null,
    titleID: data.title,
    country: countryDetails.id,
    cellNumber: data.mobile,
    physicalAddress3: data.city,
    physicalAddress4: data.state,
    physicalCode: data.postalZipCode,
    creditorExtension: {
      payToEntity: data.paymentTo,
      paymentVia: data.paymentVia,
    },
    IBAN: data.bankTypeCode === 'IBAN' ? data.iban : null,
    fBankCountry: countryDetails.id,
  };
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses() {
  return [];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepPaymentDetailsDataMapper.js